import { render, staticRenderFns } from "./OdaStatusTag.vue?vue&type=template&id=40d0d1e6"
import script from "./OdaStatusTag.vue?vue&type=script&setup=true&lang=js"
export * from "./OdaStatusTag.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports